import { Helmet } from 'react-helmet-async';
import inbanner from '../../assets/img/home-banner/ban1.jpg';
import InnerBanner from './InnerBanner';

const Domain = () => {
    return (
        <>
            <div className="page page_home">
                <Helmet>
                    <title>Domain</title>
                    <meta name='description' content='Infrastructure Energy , Information Technology Renewables' />
                    <meta name="keywords"
                        content="FirstResource, firstresource, first resource, recruitment, recruiters, talent acquisition, hiring, staffing, job placement, workforce solutions, recruitment agency, employment services, candidate sourcing, recruitment solutions, talent management, HR services, recruitment consultancy" />
                </Helmet>
                <InnerBanner />
                <div className="section indomain">
                    <div className="container indomainin">
                        <div className="row">
                            <div className="col-12 col-lg-6">
                                <h2 className="title text-center fwbold text-dark text-opacity-25 mb-5">Infrastructure Energy</h2>
                            </div>
                            <div className="col-12">
                                <h2 className="display-1 fwbold text-dark text-opacity-25 text-center mb-5">Information Technology Renewables</h2>
                            </div>
                            <div className="col-12">
                                <h2 className="title text-center fwbold text-dark text-opacity-25 mb-5">Consulting & Advisory</h2>
                            </div>
                            <div className="col-12 col-lg-6">
                                <h2 className="title text-center fwbold text-dark text-opacity-25 mb-5">Hospitality</h2>
                            </div>
                            <div className="col-12 col-lg-8">
                                <h2 className="title text-center fwbold text-dark text-opacity-25 mb-5">Manufacturing</h2>
                            </div>
                            <div className="col-12 col-lg-9">
                                <h2 className="title text-center fwbold text-dark text-opacity-25 mb-5">Projects & EPC</h2>
                            </div>
                            <div className="col-12 col-lg-6">
                                <h2 className="title text-center fwbold text-dark text-opacity-25 mb-5">Utilities</h2>
                            </div>
                            <div className="col-12">
                                <h2 className="display-3 text-center fwbold text-dark text-opacity-25 mb-5">Banking Finance Securities Insurance</h2>
                            </div>
                            <div className="col-12 col-lg-8">
                                <h2 className="title text-center fwbold text-dark text-opacity-25 mb-5">Sustainability</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default Domain;